import clsx from "clsx";
import React, { useRef } from "react";
import classes from "./PaymentStatusIndicator.module.css";
import { CheveronDown } from "../../constant";
import { ViewDetailIcon } from "../../constant";
import { TieredMenu } from "primereact/tieredmenu";
const PaymentStatusIndicator = ({
  indicator = "Active",
  bookingStatus: paymentStatus,
  menuItems,
}) => {
  const menu = useRef(null);
  const derivedStatus = () => {
    if (paymentStatus === 1) {
      return "Received";
    } else if (paymentStatus === 2) {
      return "Refunded";
    } else if (paymentStatus === 3) {
      return "Pending";
    }
  };
  const items = [
    {
      label: "View Details",
      icon: <ViewDetailIcon />,
    },
  ];
  return (
    <span className={classes.wrapper}>
      <span
        className={clsx(classes.ball, {
          [classes.confirm]: paymentStatus === 1,
          [classes.pending]: paymentStatus === 3,
          [classes.cancelled]: paymentStatus === 2,
        })}
      />
      <span className={classes.title}>{derivedStatus()}</span>
    </span>
  );
};

export default PaymentStatusIndicator;
